import { VoiceCrossFrameWrapper } from '@services/voice/VoiceCrossFrameWrapper';

const voiceCrossFrameWrapper = new VoiceCrossFrameWrapper();

/**
 * Client for the wakeWordService in base tool. {@see wakeWordService} in base tool
 * for more documentation on how this client can be used and how it can fail.
 */
export class WakeWordClient {
    /**
     * Initializes wakeWord service.
     *
     * Service always needs to be initialized first by calling warmup method,
     * otherwise wake word listening would not be possible.
     *
     * @return {Promise} Resolves if the initialization of WakeWord was successful and fails otherwise.
     */
    public static warmup() {
        return WakeWordClient.makeCrossFrameCall('warmup');
    }

    /**
     * Calls listen with the provided config. config is an optional object which overrides some default
     * configuration for wake word detection, it has the folowing structure:
     *   {
     *      timeout: {number} // wake word listening timeout in milliseconds
     *   }
     *
     * @param {object} config The config object to send.
     * @return {Promise} Resolves if the wake word detection was successful and fails otherwise.
     */
    public static listen(config: any) {
        return WakeWordClient.makeCrossFrameCall('listen', config);
    }

    /**
     * Calls cancel for cancelling the wake word listening
     *
     * @return {Promise} Resolves if the stop of WakeWord was successful and fails otherwise.
     */
    public static cancel() {
        return WakeWordClient.makeCrossFrameCall('cancel');
    }

    /**
     * Makes the cross frame call to base tool.
     */
    private static makeCrossFrameCall(action: string, parameters?: any) {
        return voiceCrossFrameWrapper.call('wakeWordListener', action, parameters);
    }
}
